import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const ThoracicSurgeryIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.0713 40C80.0713 61.8153 62.3865 79.5 40.5713 79.5C18.756 79.5 1.07129 61.8153 1.07129 40C1.07129 18.1848 18.756 0.5 40.5713 0.5C62.3865 0.5 80.0713 18.1848 80.0713 40Z'
    />
    <g clipPath='url(#clip0_414_11396)'>
      <path
        d='M33.4176 15C33.2924 15.3335 33.1848 15.6201 33.0596 15.9536C33.0495 15.9804 32.3988 17.6706 30.98 19.065C30.1569 19.874 29.0753 20.5834 27.7104 20.811C24.8704 21.2843 22.1089 22.6767 20.1328 24.6291C17.5995 27.1324 16.4825 30.3437 16.7273 33.8412C16.8603 35.7401 16.8558 37.3505 16.7832 38.6786C16.6085 41.8718 16.0389 43.4331 16.0331 43.4487C15.8943 43.8046 15.7751 44.1103 15.6362 44.4661C16.4366 45.0939 21.4212 49.0044 22.2242 49.6343C22.5296 49.4457 22.7919 49.2836 23.0972 49.095C23.6051 48.7814 24.0473 48.4361 24.4328 48.0714C24.864 47.6632 25.5243 46.7909 25.5243 46.7909C25.5243 46.7909 27.2647 48.3793 27.3359 49.1794C27.4074 49.9822 27.3658 50.7879 27.3359 51.5948V65H40.5712L42.0418 40L40.5712 15C38.6341 15 34.561 15 33.4176 15Z'
        fill='#FFCEBF'
      />
      <path
        d='M53.8066 51.6193C53.8066 51.6193 53.7346 49.9776 53.8066 49.1728C53.8783 48.3704 55.4856 46.7776 55.4856 46.7776C55.4856 46.7776 56.1474 47.6552 56.5803 48.0658C56.9671 48.4325 57.4114 48.7798 57.9218 49.095C58.2273 49.2837 58.4898 49.4459 58.7954 49.6347C65.379 44.4626 64.1894 45.3873 65.5063 44.3935C65.2965 44.0127 65.1163 43.6855 64.9067 43.3046C64.8559 43.2006 64.1369 41.6746 63.8554 38.6423C63.7335 37.3293 63.6937 35.7339 63.8256 33.8492C64.0761 30.2705 62.9041 27.0848 60.4378 24.6358C58.475 22.687 55.7218 21.2858 52.8726 20.8109C51.5165 20.5849 50.4365 19.8717 49.6126 19.059C48.1995 17.6653 47.5391 15.9789 47.53 15.9551C47.405 15.6211 47.2976 15.334 47.1726 15C45.3776 15 41.6189 15 40.5713 15V65H53.8066V58.3096V51.6193Z'
        fill='#FFBFAB'
      />
      <path
        d='M40.5036 38.2325C39.181 37.3509 37.8597 36.4698 36.537 35.5881C34.8172 35.5881 31.2145 35.5881 30.2095 35.5881V38.5293H35.6465C36.2336 38.9207 39.9126 41.3733 40.5036 41.7673C40.5135 41.7607 40.5812 41.7155 40.5714 41.7221L42.042 39.9547L40.5714 38.1874C40.5615 38.1938 40.4938 38.239 40.5036 38.2325Z'
        fill='#736DD9'
      />
      <path
        d='M50.7977 38.5293C50.7977 37.5007 50.7977 36.6168 50.7977 35.5881C49.0777 35.5881 45.4749 35.5881 44.47 35.5881C43.2307 36.4144 41.8106 37.3611 40.5713 38.1874V41.7222C41.1505 41.336 44.7774 38.918 45.3606 38.5294C47.0899 38.5293 49.0682 38.5293 50.7977 38.5293Z'
        fill='#554FB2'
      />
      <path
        d='M40.5032 47.0563C39.1807 46.1746 37.8593 45.2936 36.5366 44.4119C34.9932 44.4119 33.2231 44.4119 31.6797 44.4119V47.353H35.6462C36.2332 47.7444 39.9122 50.1971 40.5032 50.591C40.5131 50.5844 40.5809 50.5392 40.5711 50.5458L42.0416 48.7784L40.5711 47.0111C40.5612 47.0176 40.4934 47.0628 40.5032 47.0563Z'
        fill='#736DD9'
      />
      <path
        d='M49.3271 47.353C49.3271 46.3244 49.3271 45.4405 49.3271 44.4119C47.7835 44.4119 46.0134 44.4119 44.47 44.4119C43.2307 45.238 41.8106 46.1848 40.5713 47.0111V50.5459C41.1505 50.1597 44.7774 47.7418 45.3606 47.3531C46.7468 47.353 47.9408 47.353 49.3271 47.353Z'
        fill='#554FB2'
      />
      <path
        d='M39.0327 23.8235V26.7647H40.5711L41.3555 25.2941L40.5711 23.8235C40.0331 23.8235 39.5708 23.8235 39.0327 23.8235Z'
        fill='#736DD9'
      />
      <path
        d='M41.9741 23.8235C41.4834 23.8235 41.0619 23.8235 40.5713 23.8235V26.7647H41.9741C41.9741 25.736 41.9741 24.8521 41.9741 23.8235Z'
        fill='#554FB2'
      />
      <path
        d='M39.0327 29.7058V32.647H40.5711L41.0859 31.1764L40.5711 29.7058C40.0331 29.7058 39.5708 29.7058 39.0327 29.7058Z'
        fill='#736DD9'
      />
      <path
        d='M41.9741 29.7058C41.4834 29.7058 41.0619 29.7058 40.5713 29.7058V32.647H41.9741C41.9741 31.6184 41.9741 30.7344 41.9741 29.7058Z'
        fill='#554FB2'
      />
      <path
        d='M39.0327 54.7058V57.647H40.5711L41.3718 56.1764L40.5711 54.7058C40.0331 54.7058 39.5708 54.7058 39.0327 54.7058Z'
        fill='#736DD9'
      />
      <path
        d='M41.9741 54.7058C41.4834 54.7058 41.0619 54.7058 40.5713 54.7058V57.647H41.9741C41.9741 56.6184 41.9741 55.7344 41.9741 54.7058Z'
        fill='#554FB2'
      />
      <path
        d='M25.6768 64.9999H28.6335C28.6787 62.6544 28.8724 52.5992 28.8898 51.6912C28.9956 48.7954 28.5353 45.9147 27.5218 43.1289C26.8995 41.4186 26.4308 39.5643 26.1285 37.6174L23.2222 38.0686C23.5536 40.204 24.0702 42.2449 24.7578 44.1344C25.6423 46.5659 26.0434 49.0758 25.9502 51.5947L25.6768 64.9999Z'
        fill='#FFBFAB'
      />
      <path
        d='M53.4853 43.129C52.4344 46.0181 52.0156 48.9047 52.1174 51.6914C52.1942 55.7771 52.2915 60.9406 52.3679 65H55.3304C55.1839 57.8128 55.1901 58.1186 55.0574 51.607C55.0607 51.3293 54.9595 49.8606 55.2905 47.8069C55.49 46.5692 55.8101 45.3421 56.2493 44.1346C56.9221 42.2851 57.4479 40.2386 57.7848 38.0689C56.7683 37.911 55.8949 37.7754 54.8784 37.6174C54.5908 39.469 54.1336 41.347 53.4853 43.129Z'
        fill='#FFAA92'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_11396'>
        <rect width='50' height='50' fill='white' transform='translate(15.5713 15)' />
      </clipPath>
    </defs>
  </svg>
));
ThoracicSurgeryIcon.displayName = 'ThoracicSurgeryIcon';

export default ThoracicSurgeryIcon;
